import script from "./StaffDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffDetails.vue?vue&type=script&setup=true&lang=js"

import "./StaffDetails.vue?vue&type=style&index=0&id=45f81020&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45f81020"]])

export default __exports__